import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import { App } from "./App.tsx";
import { AutterErrorBoundary } from "./components/AutterErrorBoundary.tsx";
import { initAutter } from "./autter.ts";
import "./styles.css";

initAutter();

const posthogToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
// Only initialise in production builds. The dev server shares this token, so
// without this gate a local crash or event writes into the production project.
if (import.meta.env.PROD && posthogToken) {
  posthog.init(posthogToken, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    defaults: "2026-05-30",
    // Game/page/apply swap views without changing the URL; App.tsx reports
    // each view as a virtual $pageview instead.
    capture_pageview: false,
    // Lets a future backend SDK tie server events to these sessions.
    tracing_headers: [window.location.hostname],
  });
} else if (import.meta.env.PROD) {
  console.error(
    "VITE_PUBLIC_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_PUBLIC_POSTHOG_PROJECT_TOKEN is configured",
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <AutterErrorBoundary fallback={<p>Something went wrong while rendering.</p>}>
        <App />
      </AutterErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
);
